<div class="RegContainer mt-2">
    <h1>Регистрация Рационализатора</h1>
    <form [formGroup]="ratForm">
        <label>Ваши ФИО</label>
        <span *ngIf="
         ratForm.get('firstName').errors &&
         ratForm.get('firstName').hasError('required') ||
         ratForm.get('lastName').errors &&
         ratForm.get('lastName').hasError('required') ||
         ratForm.get('middleName').errors &&
         ratForm.get('middleName').hasError('required')
            " style="color: red">*</span>
        <div class="row justify-content-center">
            <input formControlName="lastName" style="max-width: 235px" class="form-control mr-2" placeholder="Укажите фамилию" />
            <input formControlName="firstName" style="max-width: 200px" class="form-control mr-2" placeholder="Укажите имя" />
            <input formControlName="middleName" style="max-width: 230px" class="form-control" placeholder="Укажите отчество" />
        </div>
        <span style="color: red" *ngIf="validFIO">Обязательные поля</span><br *ngIf="validFIO">
        <br>
        <label>Место работы (предприятие)</label>
        <br>
        <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Укажите название организации</mat-label>
            <input type="text"
                   placeholder="Укажите название организации"
                   aria-label="Укажите название организации"
                   matInput
                   formControlName="userblockInput"
                   [matAutocomplete]="auto" />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayBlockName" (optionSelected)="onBlockSelected($event.option)">
                <mat-option *ngFor="let block of blocks | async" [value]="block">{{block.name}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <span style="color: red" *ngIf="validBlock">Обязательное поле</span><br *ngIf="validBlock">
        <label style="font-style: italic">В списке представлены только предприятия - участники конкурса. Если Вашего предприятия нет в списке, его необходимо зарегистрировать со стороны Куратора</label>
        <br>

        <label>ИНН Организации</label>
        <span *ngIf="ratForm.get('Inn').errors && ratForm.get('Inn').hasError('required')" style="color: red">*</span>
        <input class="form-control" formControlName="Inn" type="text" placeholder="ИНН Организации" disabled />
        <span style="color: red" *ngIf="validInn">Обязательное поле</span><br *ngIf="validInn">
        <br>


        <label>Рацорг от вашего предприятия</label>
        <br>
        <mat-form-field appearance="fill" style="width: 100%">
            <mat-label>Рацорг от вашего предприятия</mat-label>
            <mat-select [(value)]="ratsorg.id" (selectionChange)="ratsorgChange($event)" disabled="{{enableRatsorgSelector}}">
                <mat-option *ngFor="let org of ratsorgs" [value]="org.id">
                    {{org.fullName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span style="color: red" *ngIf="validRatsorg">Обязательное поле</span><br *ngIf="validRatsorg">
        <br>
        <label>Ваш телефон</label>
        <span style="color: red" *ngIf="!(phoneInputComponent.phoneValueWithRegion.length > 10)">*</span>
        <app-phone-input>
        </app-phone-input>
        <span style="color: red" *ngIf="validPhone">Обязательное поле</span><br *ngIf="validPhone">


        <br>
        <label>Ваша электронная почта</label>
        <span *ngIf="
         ratForm.get('email').errors &&
         ratForm.get('email').hasError('required') ||
         ratForm.get('email').hasError('email')" style="color: red">*</span>
        <br>
        <label class="mt-0">Пароль для входа в систему будет отправлен на указанный email</label>

        <input class="form-control" formControlName="email" type="text" placeholder="example@org.ru" />
        <span style="color: red" *ngIf="validEmail">Обязательное поле</span><br *ngIf="validEmail">

        <label>Дата рождения</label>
        <span *ngIf="ratForm.get('birthDate').errors && ratForm.get('birthDate').hasError('required')" style="color: red">*</span>
        <input type="date" (change)="birthDateChange()" max="{{dateNow | date: 'yyyy-MM-dd'}}" formControlName="birthDate" class="form-control" required />
        <span style="color: red" *ngIf="validbirthdate">Обязательное поле</span><br *ngIf="validbirthdate">
        <br>

        <div [hidden]="hideFileInput">
            <label>Уважаемый пользователь, Вы можете принять участие в номинации «Опытный реализатор».
                Напишите эссе про опыт формирования и развития рационализаторской деятельности на вашем предприятии,
                опыт организации соц. соревнований на предприятии. Обязательно укажите Ваш суммарный опыт в
                рационализаторской деятельности - лет, месяцев. После подготовки эссе загрузите дополнительный файл в
                профиле пользователя после регистрации.</label>
        </div>

        <input type="checkbox" formControlName="userAgreement" style="width: 15px; height: 15px" class="mr-2" id="userAgreement"/><label for="userAgreement">Я принимаю <a href="themes/default/assets/documents/Пользовательское_соглашение_Конкурс_last.pdf" target="_blank">Пользовательское соглашение</a></label>
        <span *ngIf="ratForm.get('userAgreement').errors || ratForm.get('userAgreement').hasError('requiredTrue')" style="color: red">*</span>
        <br *ngIf="validUserAgreement"><span style="color: red" *ngIf="validUserAgreement">Обязательное поле</span>
        <br>
        <input type="checkbox" formControlName="personalData" style="width: 15px; height: 15px" class="mr-2" id="personalData"/><label for="personalData">Я соглашаюсь с <a href="themes/default/assets/documents/Согласие%20ПнД.pdf" target="_blank">Политикой обработки персональных данных</a></label>
        <span *ngIf="ratForm.get('personalData').errors || ratForm.get('personalData').hasError('requiredTrue')" style="color: red">*</span>
        <br *ngIf="validPersonalData"><span style="color: red" *ngIf="validPersonalData">Обязательное поле</span>
        <br>
        <app-captcha #captchaComponent></app-captcha>
        <input id="captchaCode"
               name="captchaCode"
               [(ngModel)]="captchaCode"
               class="form-control"
               autocomplete="off"
               placeholder="{{ 'Common.CaptchaText' | translate }}"
               type="text" [ngModelOptions]="{standalone: true}"/>
        <br>
        <br *ngIf="invalidCaptcha"><span style="color: red" *ngIf="invalidCaptcha">Неверно. Попробуйте еще раз!</span>
        <div class="col text-center">
            <button [disabled]="lockSubmitButton" type="button" class="btn btn-primary" (click)="submitRegistration()">Зарегистрироваться</button>
        </div>
    </form>

</div>
